<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="23cm"
            :fullscreen="fullscreen"
            :persistent="true">
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">打印建帐通知单</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <div id="printMe" class="prt-wrapper">
                    <h2 class="x-center">科技计划项目 建帐通知单</h2>
                    <p class="x-single-line x-right">经费单位：人民币元</p>
                    <table cellspacing="0">
                        <tr>
                            <td class="x-center" style="width: 6em">项目名称</td>
                            <td colspan="5">
                                {{ proj.name}}
                            </td>
                        </tr>
                        <tr>
                            <td class="x-center">项目类别</td>
                            <td style="min-width: 10em">
                                {{ proj.type? proj.type.name : ''}}
                            </td>
                            <td class="x-center" style="width: 6em">项目编号</td>
                            <td style="width: 9em">
                                {{ proj.code}}
                            </td>

                            <td class="x-center" style="width: 5em">批准号</td>
                            <td style="width: 9em">
                                {{ proj.number}}
                            </td>

                        </tr>
                        <tr>
                            <td class="x-center">承担单位</td>
                            <td>{{ proj.department? proj.department.name : ''}}</td>
                            <td class="x-center">项目负责人</td>
                            <td colspan="3">{{ proj.leaderName}} {{ proj.leaderPhone || ''}}</td>
                        </tr>
                        <tr>
                            <td class="x-center">拔款单位</td>
                            <td colspan="5">{{item.drawee}}</td>
                        </tr>
                        <tr>
                            <td class="x-center">到款日期</td>
                            <td>{{item.paymentDate}}</td>
                            <td class="x-center">到款次数</td>
                            <td >{{ item.serialNum}}（{{ item.property}}）</td>
                            <td class="x-center">建帐方式</td>
                            <td class="" v-if="item.kyYwTrans">
                              自动<br/>
                              {{ item.kyYwTrans.pch }}
<!--                              <br/>-->
<!--                              <span v-if="item.kyYwTrans.iscl" style="color: steelblue">财务已处理</span>-->
<!--                              <span v-else>财务未处理</span>-->
                            </td>
                            <td class="" v-else>手工</td>
                        </tr>
                        <tr>
                            <td class="x-center">合同经费</td>
                            <td>{{ proj.contractAmounts | currency}}</td>
                            <td class="x-center">项目开始日期</td>
                            <td>{{ proj.startDate}}</td>
                            <td class="x-center">项目结束日期</td>
                            <td>{{ getfinishdate}}</td>
                        </tr>
                        <tr>
                            <td class="x-center">到款经费</td>
                            <td>{{ item.amount | currency}}</td>
                            <td class="x-center">研究经费</td>
                            <td >{{ item.researchFund | currency}}</td>
                            <td class="x-center">资金性质</td>
                            <td >{{ item.lkbzOpt}}</td>
                        </tr>

                        <tr>
                            <td class="x-center">序号</td>
                            <td>项目</td>
                            <td class="x-center">比例</td>
<!--                          <td class="x-center">经费卡</td>-->
                            <td class="x-center"></td>
                            <td colspan="2" class="x-right">金额</td>
                        </tr>
                        <tr v-for="(it, idx) in item.fundItems" :key="idx+1">
                            <td class="x-center">
                                {{idx + 1}}
                            </td>
                            <td class="x-left">
                                <span :style="{paddingLeft:(it.level-1) + 'em'}">{{it.partitionName}}</span>
                            </td>
                            <td class="x-center">
                                {{ Math.round(Number(it.percent * 100)) / 100 }}%
                            </td>
                            <td class="x-center">
<!--                                {{it.cardNumber}}-->
                            </td>
                            <td class="x-right" colspan="3">{{ it.amount | currency }}
                            </td>
                        </tr>

                        <tr>
                            <td class="x-center">填表人</td>
                            <td>{{name}}</td>
                            <td class="x-center">备注</td>
                            <td >{{item.note}}</td>
                            <td class="x-center">预算管理</td>
                            <td class="x-center">{{buget}}</td>
                        </tr>
                        <tr>
                            <td class="x-center" style="padding-top: 1.5em;padding-bottom: 1.5em;">科学技术院签章</td>
                            <td>&nbsp;</td>
                            <td class="x-center">财务处签章</td>
                            <td colspan="3">&nbsp;</td>
                        </tr>
                    </table>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn flat color="primary" @click.native="visible=false">关闭</v-btn>
                <v-btn v-print="'#printMe'" color="primary">打印</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {mapGetters} from 'vuex'

    import mixin from '@/mixin'

    const baseURI = '/api/proj/fund/income';

    export default {
        mixins: [mixin.view(baseURI)],
        props: ['value', 'dbid', "project" ,"buget"],

        data() {
            return {
                item: {
                    "partition": {}
                },

                projFinishDate : '',
                curDate : '',
                nextDate : '',
                lastDate : '',
                tyear : '',
                tmonth : '',
                tday : '',

                projFundType : '',//判断项目经费是否财政资金，纵向为zx

                headers: [
                    {text: '#', sortable: false, value: 'rank', width: 18},
                    {text: '拆分项目名称', sortable: false, value: 'name'},
                    {text: '经费百分比', sortable: false, value: 'percent'},
                    {text: '金额（元）', sortable: false, value: 'note', width: 230},
                ],
            }
        },

        watch: {
          project(project){
            if(project.type.category == 'zx')
            {
              this.projFundType = 'zx'
            }
          },
        },

        computed: {
            proj() {
                return this.project || {};
            },

            getfinishdate() {
              const vm = this
              if (this.proj.finishDate) {
              vm.projFinishDate = this.proj.finishDate
              vm.curDate = new Date(vm.projFinishDate)
              vm.nextDate = vm.curDate.setYear(vm.curDate.getFullYear() + 2)
              vm.lastDate = new Date(vm.nextDate)
              vm.tyear = vm.lastDate.getFullYear()
              vm.tmonth = vm.lastDate.getMonth() + 1
              vm.tday = vm.lastDate.getDate()
              vm.tmonth = vm.tmonth < 10 ? "0" + vm.tmonth : vm.tmonth
              vm.tday = vm.tday < 10 ? "0" + vm.tday : vm.tday
              return `${vm.tyear}-${vm.tmonth}-${vm.tday}`
            }
            },
            ...mapGetters([
                'authenticated',
                'name'
            ])
        },

    }
</script>

